package com.example.mystybag.pdf.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.openSettings
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.model.AdditionalIcon
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.expected.sharedActivity
import com.example.mystybag.pdf.helpers.showStoragePermissionDeniedDialog
import com.example.mystybag.pdf.model.PdfFileUIState
import com.example.mystybag.pdfUtils.expected.PDFHelper
import com.example.mystybag.pdfUtils.expected.PdfFile
import com.example.mystybag.pdfUtils.expected.copyToExternalDisk
import com.example.mystybag.pdfUtils.expected.sharePDF
import com.example.mystybag.permissionsUtils.expected.Permission
import com.example.mystybag.permissionsUtils.expected.PermissionHelper

class PdfFileViewModel(context: AppContext, val title: String, val file: PdfFile, val withSave: Boolean): ChildViewModel<PdfFileUIState>(context, PdfFileUIState(file, withSave)) {

    override fun onCreate() {
        navControls.title           = title
        navControls.additionalIcons = listOf(
            AdditionalIcon(
                image   = SRC.images.print_icon,
                action  = { PDFHelper().printFile("mystybag_statement_$title.pdf", uiState.value.file) }
            ),
            AdditionalIcon(
                image  = SRC.images.share_icon,
                action = { sharePDF(uiState.value.file, "$title.pdf") }
            )
        )
    }

    fun onSaveFileClicked() {
        launchOnMain {
            if (PermissionHelper.requestPermission(Permission.WriteExternalStorage, sharedActivity))
                downloadPdf()
        }
    }

    private fun downloadPdf() {
        if (uiState.value.file.copyToExternalDisk("mystybag_statement_$title.pdf"))
            showSnackbar(SR.strings.successfully_saved_to_device)
        else
            showSnackbar(SR.strings.download_failed)
    }

    fun showPermissionDialog() {
        uiThread {
            showStoragePermissionDeniedDialog(
                sharedString(SR.strings.storage_permission),
                sharedString(SR.strings.settings),
                sharedString(SR.strings.cancel)
            ) {
                openSettings()
            }
        }
    }
}